import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import styled from 'styled-components';
import {
  standardTransition,
  minBreakpointQuery,
  sectionMargins,
  brandColours,
} from '../utilities';
import { Container, HeadingWithBackgroundText, ResRetImg } from './ui';

const GallerySlider = styled(Slider)`
  margin-top: 52px;

  ${minBreakpointQuery.large`
    margin-top: 72px;
  `}

  .slick-slide {
    padding: 0 9px;
    ${standardTransition('opacity')};

    ${minBreakpointQuery.large`
      width: 100%;
      max-width: 984px;
      padding: 0 15px;
    `}

    ${minBreakpointQuery.xxlarge`
      padding: 0 22px;
    `}

    &:not(.slick-active) {
      opacity: 0.5;
    }
  }

  .slick-dots {
    padding-top: 16px;
    text-align: center;
    li {
      display: inline-block;
    }
  }
`;

const Gallery = styled.section`
  ${sectionMargins()};
`;

const Dot = styled.span`
  height: 11px;
  width: 11px;
  display: block;
  margin: 0 4px;
  border-radius: 100%;
  background: ${brandColours.quinary};
  cursor: pointer;

  .slick-active & {
    height: 13px;
    width: 13px;
    background: ${brandColours.primary};
    transform: translateY(1px);
  }
`;

const options = {
  arrows: false,
  dots: true,
  centerMode: true,
  variableWidth: true,
  customPaging: () => <Dot />,
  responsive: [
    {
      breakpoint: 1120,
      settings: {
        slidesToShow: 1,
        slidesPerRow: 1,
        variableWidth: false,
      },
    },
  ],
};

export default ({ heading, headingBackgroundText, images }) => {
  return (
    <Gallery>
      <Container>
        <HeadingWithBackgroundText
          heading={heading}
          headingBackgroundText={headingBackgroundText}
        />
      </Container>
      <GallerySlider {...options}>
        {images.map(image => (
          <ResRetImg key={`gallery-slider-${image.id}`} image={image} />
        ))}
      </GallerySlider>
    </Gallery>
  );
};
